export default {
  MuiChip: {
    styleOverrides: {
      root: {
        fontSize: '14px',
        height: '32px',
        borderRadius: '4px'
      },
      label: {
        paddingTop: '2px',
        paddingBottom: '2px'
      },
      colorDefault: {
        color: '#000000',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      },
      colorPrimary: {
        color: '#000000',
        backgroundColor: '#F0F0F0'
      }
    }
  }
};
